import { API } from 'aws-amplify';
import { riskScore } from '../../common/graphql/queries';

export const callRiskScorePrediction = async (input: any): Promise<string> => {

    console.log(prompt);

    try {
        const response: any = await API.graphql({
            query: riskScore,
            variables: {
                input: JSON.stringify(input),
            }
        });
        console.log('callRiskScorePrediction response', response);
        return response["data"]["riskScore"];
    } catch (err: any) {
        console.error(err)
        console.log("Error when calling callRiskScorePrediction");
        return "";
    }
}
